'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const WorkProcess: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
					Процесс работы
					</Typography>
					<Typography 
						variant='h2' 
						className={styles.title}
						dangerouslySetInnerHTML={{ __html: 'Прозрачная система управления <span>задачами и отчетностью</span>' }}
					/>
					<Typography variant='p1' color='description' className={styles.description}>
					Вы получаете полный контроль над процессами, прогнозируемый результат и детальную отчётность по каждой задаче из сметы.
					</Typography>
				</div>
			</AnimatedSection>

			<AnimatedSection animation="slideUp">
				<div className={styles.imageContainer}>
					<Image
						src="/images/services/work-process-desktop.svg"
						alt="Процесс работы"
						width={1110}
						height={610}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src="/images/services/work-process-tablet.svg"
						alt="Процесс работы"
						width={680}
						height={670}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src="/images/services/work-process-mobile.svg"
						alt="Процесс работы"
						width={328}
						height={712}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

WorkProcess.displayName = 'WorkProcess'

export default WorkProcess

